/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActiveIngredientDto } from './ActiveIngredientDto';
import {
    ActiveIngredientDtoFromJSON,
    ActiveIngredientDtoFromJSONTyped,
    ActiveIngredientDtoToJSON,
    ActiveIngredientDtoToJSONTyped,
} from './ActiveIngredientDto';
import type { MedicineInOrderResponseDto } from './MedicineInOrderResponseDto';
import {
    MedicineInOrderResponseDtoFromJSON,
    MedicineInOrderResponseDtoFromJSONTyped,
    MedicineInOrderResponseDtoToJSON,
    MedicineInOrderResponseDtoToJSONTyped,
} from './MedicineInOrderResponseDto';
import type { GetMedicinesInPrescriptionOrderResponseDto } from './GetMedicinesInPrescriptionOrderResponseDto';
import {
    GetMedicinesInPrescriptionOrderResponseDtoFromJSON,
    GetMedicinesInPrescriptionOrderResponseDtoFromJSONTyped,
    GetMedicinesInPrescriptionOrderResponseDtoToJSON,
    GetMedicinesInPrescriptionOrderResponseDtoToJSONTyped,
} from './GetMedicinesInPrescriptionOrderResponseDto';
import type { MedicineResponseDto } from './MedicineResponseDto';
import {
    MedicineResponseDtoFromJSON,
    MedicineResponseDtoFromJSONTyped,
    MedicineResponseDtoToJSON,
    MedicineResponseDtoToJSONTyped,
} from './MedicineResponseDto';

/**
 * 
 * @export
 * @interface GetMedicinesInPrescriptionOrder200Response
 */
export interface GetMedicinesInPrescriptionOrder200Response {
    /**
     * List of medicines in the prescription order
     * @type {Array<MedicineInOrderResponseDto>}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    medicines: Array<MedicineInOrderResponseDto>;
    /**
     * Medicine ID
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    id: string;
    /**
     * Package NDC
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    packageNdc?: string;
    /**
     * Brand name base
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    brandNameBase?: string;
    /**
     * Brand name
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    brandName?: string;
    /**
     * Package description
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    description?: string;
    /**
     * Active ingredients
     * @type {Array<ActiveIngredientDto>}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    activeIngredients?: Array<ActiveIngredientDto>;
    /**
     * Labeler name
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    labelerName?: string;
    /**
     * Dosage form
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    dosageForm?: string;
    /**
     * Route of administration
     * @type {Array<string>}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    route?: Array<string>;
    /**
     * Medicine name (legacy - fallback from brandName)
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    name?: string;
    /**
     * Medicine code (legacy - fallback from packageNdc)
     * @type {string}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    code?: string;
    /**
     * Created at
     * @type {Date}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    createdAt: Date;
    /**
     * Updated at
     * @type {Date}
     * @memberof GetMedicinesInPrescriptionOrder200Response
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the GetMedicinesInPrescriptionOrder200Response interface.
 */
export function instanceOfGetMedicinesInPrescriptionOrder200Response(value: object): value is GetMedicinesInPrescriptionOrder200Response {
    if (!('medicines' in value) || value['medicines'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetMedicinesInPrescriptionOrder200ResponseFromJSON(json: any): GetMedicinesInPrescriptionOrder200Response {
    return GetMedicinesInPrescriptionOrder200ResponseFromJSONTyped(json, false);
}

export function GetMedicinesInPrescriptionOrder200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMedicinesInPrescriptionOrder200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'medicines': ((json['medicines'] as Array<any>).map(MedicineInOrderResponseDtoFromJSON)),
        'id': json['id'],
        'packageNdc': json['packageNdc'] == null ? undefined : json['packageNdc'],
        'brandNameBase': json['brandNameBase'] == null ? undefined : json['brandNameBase'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'description': json['description'] == null ? undefined : json['description'],
        'activeIngredients': json['activeIngredients'] == null ? undefined : ((json['activeIngredients'] as Array<any>).map(ActiveIngredientDtoFromJSON)),
        'labelerName': json['labelerName'] == null ? undefined : json['labelerName'],
        'dosageForm': json['dosageForm'] == null ? undefined : json['dosageForm'],
        'route': json['route'] == null ? undefined : json['route'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function GetMedicinesInPrescriptionOrder200ResponseToJSON(json: any): GetMedicinesInPrescriptionOrder200Response {
    return GetMedicinesInPrescriptionOrder200ResponseToJSONTyped(json, false);
}

export function GetMedicinesInPrescriptionOrder200ResponseToJSONTyped(value?: GetMedicinesInPrescriptionOrder200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicines': ((value['medicines'] as Array<any>).map(MedicineInOrderResponseDtoToJSON)),
        'id': value['id'],
        'packageNdc': value['packageNdc'],
        'brandNameBase': value['brandNameBase'],
        'brandName': value['brandName'],
        'description': value['description'],
        'activeIngredients': value['activeIngredients'] == null ? undefined : ((value['activeIngredients'] as Array<any>).map(ActiveIngredientDtoToJSON)),
        'labelerName': value['labelerName'],
        'dosageForm': value['dosageForm'],
        'route': value['route'],
        'name': value['name'],
        'code': value['code'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

